//
//
//
//
//
//
//
//
//
//
//
//

// 账号密码登录页面
// @author Rico
import Storage from "@/utils/storage";
import { addToken } from "@/utils/index";
import PasswordLoginForm from "@/components/forms/PasswordLoginForm";

export default {
  name: "Login",
  componentName: "Login",
  components: {
    PasswordLoginForm,
  },
  methods: {
    onSuccess() {
      const returnUrl = Storage.get("returnUrl");
      const identityToken = Storage.get("identityToken");
      if (returnUrl) {
        window.location.href = addToken(
          decodeURIComponent(returnUrl),
          identityToken
        );
      } else {
        window.location.href = addToken(window.location.origin, identityToken);
      }
    },
    onGoto(route) {
      window.location.href = `/${route}`;
    },
  },
};
